import React from 'react';
import EventForm from '../components/EventForm';
import ScreenHeader from '../components/ScreenHeader';
import SaveButton from '../components/SaveButton';

export default function EditScreen({
  editForm,
  selectedTags, toggleTag,
  setCurrentScreen,
  handleSaveEditedEvent,
}) {
  return (
    <div className="h-full flex flex-col bg-white">
      <ScreenHeader
        title="Edit Event"
        onBack={() => setCurrentScreen('detail')}
        titleClassName="text-2xl font-bold text-gray-900"
      />
      <EventForm form={editForm} selectedTags={selectedTags} toggleTag={toggleTag} />
      <SaveButton onSave={handleSaveEditedEvent} isSaving={editForm.isSaving} />
    </div>
  );
}
